<div class="create-content">
  <form [formGroup]="form" (ngSubmit)="create()" class="application-page" [ngClass]="{ edit: edit }">
    <div class="container-fluid" [nbSpinner]="processing">
      <div class="row justify-content-center">
        <div
          [ngClass]="{
            'col-12 col-lg-12 col-md-12 col-sm-12': !edit,
            'col-12 edit': edit
          }"
        >
          <nb-card [nbSpinner]="!ready">
            <nb-card-body>
              <div class="flex-grow-1 form-padded">
                <div class="modal-title" [ngClass]="{ editTitle: edit }">
                  {{ edit ? 'Workspace information' : 'Creating a new workspace' }}
                </div>
              </div>
              <div class="form-fields">
                <p class="field-name" *ngIf="edit">Workspace name</p>
                <nb-form-field>
                  <mat-icon nbPrefix>cases</mat-icon>
                  <input type="text" fullWidth nbInput formControlName="name" placeholder="Workspace Name" />
                  <mat-icon nbSuffix tabindex="0" matTooltip="Help you to find specific workspace by its name" matTooltipPosition="above">help_outline</mat-icon>
                </nb-form-field>
                <p class="field-name" *ngIf="edit">Contact email</p>
                <nb-form-field *ngIf="edit">
                  <mat-icon nbPrefix>alternate_email</mat-icon>
                  <input type="text" fullWidth nbInput formControlName="contact_email" placeholder="Contact email" />
                  <mat-icon nbSuffix tabindex="0" matTooltip="Contact email which registrants can use to communicate with you" matTooltipPosition="above">help_outline</mat-icon>
                </nb-form-field>
                <p class="field-name" *ngIf="edit">Contact phone number</p>
                <nb-form-field *ngIf="edit">
                  <mat-icon nbPrefix>phone</mat-icon>
                  <input type="phone" fullWidth nbInput [ngxPhoneNumberInput] formControlName="contact_number" placeholder="Contact phone number" />
                  <mat-icon nbSuffix tabindex="0" matTooltip="Contact phone number which registrants can use to communicate with you" matTooltipPosition="above"
                    >help_outline</mat-icon
                  >
                </nb-form-field>

                <div class="position-relative">
                  <nb-form-field *ngIf="!edit">
                    <mat-icon nbPrefix>cases</mat-icon>
                    <input
                      (ngModelChange)="slugChanged($event)"
                      [(ngModel)]="workspaceSlug"
                      type="text"
                      fullWidth
                      nbInput
                      [disabled]="edit"
                      formControlName="slug"
                      placeholder="Workspace acronym"
                      pattern="([a-zA-Z]+[a-zA-Z0-9\-]*)"
                    />
                    <mat-icon nbSuffix tabindex="0" matTooltip="Help you to find specific workspace by its acronym" matTooltipPosition="above">help_outline</mat-icon>
                  </nb-form-field>
                  <div
                    class="text-danger pl-2 error-message"
                    *ngIf="form.controls['slug']['touched'] && form.controls['slug']['errors'] && form.controls['slug']['errors']['pattern']"
                  >
                    Workspace acronym doesn't accept special characters
                  </div>
                </div>
                <nb-form-field *ngIf="!edit">
                  <mat-icon nbPrefix>alternate_email</mat-icon>
                  <input type="text" nbInput formControlName="email" fullWidth placeholder="Workspace manager's email" />
                  <mat-icon nbSuffix tabindex="0" matTooltip="Help you to contact with Workspace manager's via his email" matTooltipPosition="above">help_outline</mat-icon>
                </nb-form-field>
                <form [formGroup]="organizationForm" *ngIf="organizationForm && edit">
                  <h6 class="my-3">Organization information</h6>
                  <div class="mt-4">
                    <p class="field-name" *ngIf="edit">Country</p>
                    <nb-form-field>
                      <nb-select
                        formControlName="country"
                        placeholder="Country"
                        fullWidth
                        [status]="organizationForm.controls['country'].errors && organizationForm.controls['country'].dirty ? 'danger' : 'basic'"
                      >
                        <nb-option value="" *ngIf="!organizationForm.value.country">
                          <div class="d-flex flex-center">Select</div>
                        </nb-option>
                        <nb-option *ngFor="let country of countries" [value]="country.iso2">
                          <div class="d-flex flex-center"><img [src]="country.flag" /> {{ country.name }}</div>
                        </nb-option>
                      </nb-select>
                    </nb-form-field>
                    <p class="field-name" *ngIf="edit">Entity type</p>
                    <nb-form-field>
                      <nb-select
                        formControlName="company_type"
                        placeholder="Entity type"
                        fullWidth
                        [status]="organizationForm.controls['company_type'].errors && organizationForm.controls['company_type'].dirty ? 'danger' : 'basic'"
                      >
                        <nb-option *ngFor="let type of entityTypes" [value]="type.value">
                          <div class="d-flex flex-center">
                            {{ type.name }}
                          </div>
                        </nb-option>
                      </nb-select>
                    </nb-form-field>
                    <p class="field-name" *ngIf="edit">Business legal name</p>
                    <nb-form-field>
                      <mat-icon nbPrefix> cases</mat-icon>
                      <input
                        formControlName="company_name"
                        [type]="'text'"
                        nbInput
                        fullWidth
                        placeholder="Business legal name"
                        [status]="organizationForm.controls['company_name'].errors && organizationForm.controls['company_name'].dirty ? 'danger' : 'basic'"
                      />
                    </nb-form-field>
                    <p class="field-name" *ngIf="edit">Organization email</p>
                    <nb-form-field>
                      <mat-icon nbPrefix> alternate_email</mat-icon>
                      <input
                        formControlName="company_email"
                        [type]="'email'"
                        nbInput
                        fullWidth
                        placeholder="Organization email"
                        [status]="organizationForm.controls['company_email'].errors && organizationForm.controls['company_email'].dirty ? 'danger' : 'basic'"
                      />
                    </nb-form-field>
                    <span *ngIf="organizationForm.controls['company_email'].errors && organizationForm.controls['company_email'].dirty"> Email is invalid </span>
                    <p class="field-name" *ngIf="edit">Organization phone number</p>
                    <nb-form-field *ngIf="edit">
                      <mat-icon nbPrefix>phone</mat-icon>
                      <input type="phone" fullWidth nbInput [ngxPhoneNumberInput] formControlName="company_phone" placeholder="Organization phone number" />
                      <mat-icon nbSuffix tabindex="0" matTooltip="Organization phone number" matTooltipPosition="above">help_outline</mat-icon>
                    </nb-form-field>
                    <p class="field-name" *ngIf="edit">Organization address</p>
                    <nb-form-field *ngIf="edit">
                      <mat-icon nbPrefix>home</mat-icon>
                      <input type="text" fullWidth nbInput [ngxPhoneNumberInput] formControlName="company_address" placeholder="Organization address" />
                      <mat-icon nbSuffix tabindex="0" matTooltip="Organization address" matTooltipPosition="above">help_outline</mat-icon>
                    </nb-form-field>
                  </div>
                </form>
                <div class="my-4" *ngIf="organizationForm && edit">
                  <div class="align-items-center d-flex justify-content-between mb-3 title">
                    <h6>Payment processing</h6>
                    <nb-tag [status]="hasStripeConnect ? 'success' : 'primary'" appearance="outline" [text]="hasStripeConnect ? 'Connected' : 'Not connected'"></nb-tag>
                  </div>
                  <button class="mb-3" nbButton [status]="hasStripeConnect ? 'warning' : 'primary'" (click)="redirectToStripe($event)" fullWidth>
                    {{ hasStripeConnect ? 'Disconnect your Stripe Account' : 'Connect Stripe Account' }}
                  </button>
                  <span class="small stripe-warning"
                    >Don't have a stripe account? no problem, <span class="font-weight-bold">collect payments in 21+ currencies, </span
                    ><a (click)="requestOtherPaymentProvider()" class="font-weight-bold">click here</a> to request payment collection.
                  </span>
                </div>
                <div *ngIf="auth.role === 'Admin'">
                  <!-- PLAN SELECTION-->
                  <div class="plan-selection" *ngIf="isMainEntity()">
                    <div class="section-header">
                      PRO Plan
                      <small class="text-hint"> - Toggle to activate and set expiry date </small>
                    </div>
                    <div class="pro-option-expiry">
                      <nb-toggle formControlName="pro"> </nb-toggle>
                      <nb-form-field *ngIf="form.value.pro">
                        <input [nbDatepicker]="datepicker" fullWidth nbInput placeholder="Manually activated until" formControlName="plan_expiry_date" />
                        <nb-datepicker #datepicker></nb-datepicker>
                        <mat-icon nbPrefix nbTooltip="Manually activate PRO subscription until the selected date"> help_outline</mat-icon>
                      </nb-form-field>
                    </div>
                    <!-- /PLAN SELECTION-->
                  </div>
                  <div class="d-flex align-items-center mt-4" *ngIf="edit">
                    <mat-icon class="text-black-50 mr-3">payment</mat-icon>
                    <div class="w-100">
                      <p class="field-name" *ngIf="edit">Payment processing</p>
                      <nb-select
                        placeholder="Payment processing"
                        fullWidth
                        (ngModelChange)="changePaymentGateway($event)"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="gateway"
                        [(selected)]="gateway"
                      >
                        <nb-option *ngFor="let paymentGateway of availableGateways" [value]="paymentGateway.name">
                          <div class="d-flex flex-center">
                            <pre class="m-0" *ngIf="!paymentGateway.id && paymentGateway.label !== 'None'">&emsp;</pre>
                            {{ paymentGateway.label }}
                          </div>
                        </nb-option>
                      </nb-select>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="edit" [ngClass]="{ editBtns: edit }">
                <button nbButton full-width status="primary" class="mt-4 full-width" [disabled]="!form.valid" type="submit">Save</button>
                <button type="button" *ngIf="auth.isAdmin" (click)="deleteWorkSpace()" nbButton full-width class="delete-button mt-1 full-width">Delete workspace</button>
              </div>
              <div *ngIf="!edit" [ngClass]="{ createBtns: !edit }">
                <button nbButton status="basic" class="mr-2" (click)="close()">Cancel</button>
                <button nbButton status="primary" class="ml-2" [disabled]="!form.valid" type="submit">Save</button>
              </div>
              <div class="go-archive-list" *ngIf="edit">
                <a (click)="goToArchiveList()">
                  <span class="icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.73619 2.74829C3.10432 2.74829 2.56281 2.973 2.10951 3.4263C1.65622 3.8796 1.42871 4.4239 1.42871 5.05577V14.9442C1.42871 15.576 1.65622 16.1203 2.10951 16.5736C2.56281 17.0269 3.10432 17.2516 3.73619 17.2516H16.2641C16.896 17.2516 17.4375 17.0269 17.8908 16.5736C18.3441 16.1203 18.5716 15.576 18.5716 14.9442V7.69249C18.5716 7.06062 18.3441 6.51911 17.8908 6.06581C17.4375 5.61252 16.896 5.38501 16.2641 5.38501H9.34166V5.05577C9.34166 4.4239 9.11415 3.8796 8.66085 3.4263C8.20756 2.973 7.66605 2.74829 7.03418 2.74829H3.73619ZM6.42592 6.83311H9.64021C9.78753 6.83311 9.99363 6.91868 10.0978 7.02284L12.9326 9.85767C13.0368 9.96183 13.1224 10.1679 13.1224 10.3153V15.1367C13.1224 15.284 13.0018 15.4045 12.8545 15.4045H6.42592C6.2786 15.4045 6.15806 15.284 6.15806 15.1367V7.10097C6.15806 6.95365 6.2786 6.83311 6.42592 6.83311ZM11.2474 6.83311H12.8545C13.0018 6.83311 13.1224 6.95365 13.1224 7.10097V8.70811C13.1224 8.85543 13.0368 8.89042 12.9326 8.78624L11.1692 7.02284C11.0651 6.91868 11.1 6.83311 11.2474 6.83311ZM6.69378 7.36883V14.8688H12.5866V10.3236C12.5826 10.2992 12.5648 10.2516 12.5504 10.2315L9.72391 7.4051C9.70381 7.39067 9.65624 7.37311 9.63184 7.36883H6.69378ZM8.96219 8.09985H9.57603V8.7109H10.1871V9.32474H9.57603V9.93579H10.1871V10.5496H9.57603V11.1607H9.95271C10.0229 11.1607 10.0854 11.1806 10.1396 11.2221C10.1939 11.2635 10.2321 11.3197 10.2513 11.3867L10.7619 13.0552C10.7874 13.1413 10.8009 13.2238 10.8009 13.3035C10.8009 13.5682 10.6833 13.7882 10.4521 13.962C10.221 14.1358 9.92999 14.2215 9.57603 14.2215C9.22208 14.2215 8.92831 14.1358 8.69713 13.962C8.46594 13.7882 8.35114 13.5682 8.35114 13.3035C8.35114 13.2238 8.36468 13.1413 8.39021 13.0552C8.45717 12.8543 8.6493 12.2225 8.96498 11.1607V10.5496H9.57603V9.93579H8.96219V9.32474H9.57603V8.7109H8.96219V8.09985ZM9.57603 12.9966C9.40703 12.9966 9.26313 13.0281 9.14356 13.0887C9.02397 13.1493 8.96219 13.2206 8.96219 13.3035C8.96219 13.3864 9.02398 13.4578 9.14356 13.5184C9.26313 13.579 9.40703 13.6105 9.57603 13.6105C9.74504 13.6105 9.88894 13.579 10.0085 13.5184C10.1281 13.4578 10.1871 13.3864 10.1871 13.3035C10.1871 13.2206 10.1281 13.1493 10.0085 13.0887C9.88894 13.0281 9.74504 12.9966 9.57603 12.9966Z"
                        fill="#3366FF"
                      />
                    </svg>
                  </span>
                  <span class="text"> Show archived events. </span>
                </a>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
    </div>
  </form>
</div>
<ng-template #dialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>
      <span>
        Workspace
        <span class="site">{{ dialogData.slug }}</span> has been created
      </span>
    </nb-card-header>
    <nb-card-body>
      <span>
        Email with login credentials has been sent to
        <span class="email"> {{ dialogData.email }} </span>
      </span>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton fullWidth status="primary" (click)="ref.close()">OK</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

@if (showPaidEventsInviteModal && paidEventsInvitationInfo) {
  <ngx-invitation
    [modalId]="paidEventsInviteModalId"
    [invitationInfo]="paidEventsInvitationInfo"
    [paidEvents]="paidEvents"
    (closed)="onPaidEventsInviteModalClosed()"
  ></ngx-invitation>
}
